import * as React from 'react'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import * as sx from '../common/stylesInline/report_daily_branch'
import { Item } from './snippets'
import { useEffect } from 'react'
import { focusElemnt } from './helper'

export const SplitButton = (props) => {
  const { options, hideToggle = false, onClick1, onClick2, id1, id2, idnav, prevID, disabled = false } = props
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)
  const [selectedIndex, setSelectedIndex] = React.useState(1)
  const [secondButtonStyle, setSecondButtonStyle] = React.useState({ width: 0, height: 0 })

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`)
  }

  const handleMenuItemClick = (event, index = 1) => {
    setSelectedIndex(index)
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }
  useEffect(() => {
    if (anchorRef) {
      const dims = anchorRef.current.getBoundingClientRect()
      const style = {}
      style.width = dims.width
      style.height = dims.height
      setSecondButtonStyle(style)
    }
  }, [anchorRef])

  return (
    <React.Fragment>
      <ButtonGroup sx={{ margin: '0' }} style={{ whiteSpace: 'nowrap' }} variant="contained" ref={anchorRef} aria-label="split button" disabled={disabled}>
        <Button onClick={onClick1} style={{ ...sx.novp,height:'40px' }} id={id1} className="btn btn-primary" onKeyDown={(e)=>e.key === 'Escape'?focusElemnt(prevID):()=>{}}>
          {options[0]}
        </Button>
        {!hideToggle && (
          <Button
            variant="contained"
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
            className="btn btn-primary"
            sx={{ width: '40px', height: '40px' }}
            id={idnav}
          >
            <ArrowDropDownIcon />
          </Button>
        )}
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <Button
                  aria-controls={open ? 'split-button-menu' : undefined}
                  aria-expanded={open ? 'true' : undefined}
                  aria-label="select merge strategy"
                  onClick={onClick2}
                  className="btn split-cancel-btn"
                  sx={secondButtonStyle}
                  id={id2}
                >
                  {options[1]}
                </Button>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  )
}
